import api from 'apiModule/rest';
import { getQueriesString } from 'utilsModule';
import { isNil } from 'ramda';

// fetch notes
const fetchList = body => api.note.fetchList('note/list', body);

// fetch notes
const fetchQuestionnaireNoteList = body => {
  const data = []
  Object.keys(body).map((key) => {
    data.push(
      {
        name: key,
        value: body[key]
      }
    )
  })
  const queryString = getQueriesString(data)
  return api.note.fetchGetList(`questionnaire/note${queryString}`)
};

// create notes
const create = body => api.note.create('note/create', body);

// create notes
const createQuestionnaireNote = body => api.note.create('questionnaire/note', body);

// mark note as error
const markAsError = body => api.note.markAsError('note/markNoteAsError', body);

// mark note as error
const markQuestionnaireNoteAsError = body => api.note.markAsError('questionnaire/note/markNoteAsError', body);

export default {
  fetchList,
  create,
  markAsError,
  createQuestionnaireNote,
  fetchQuestionnaireNoteList,
  markQuestionnaireNoteAsError
};
